import { useEffect, useState } from 'react';
import { Fetch } from '../helpers/fetchWrapper';
import { useCancellablePromise } from '../helpers/promiseHandler';

const STATUS = {
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};

const configurationService = {
  _url: `${process.env.REACT_APP_CONFIG_API_URL}`,

  GetConfigurationTemplate(searchQuery, fetch) {
    const [configTemplates, setConfigTemplates] = useState({
      configTemplates: [],
      totalItems: 0,
    });
    const { cancellablePromise } = useCancellablePromise();
    const [status, setStatus] = useState(STATUS.LOADING);
    useEffect(() => {
      setStatus(STATUS.LOADING);
      cancellablePromise(this.getConfigurationTemplates(searchQuery))
        .then(res => {
          setConfigTemplates(() => res);
          setStatus(STATUS.SUCCESS);
        })
        .catch(() => setStatus(STATUS.ERROR));
    }, [
      searchQuery?.page,
      searchQuery?.pageSize,
      searchQuery?.searchText,
      searchQuery?.startDate,
      searchQuery?.endDate,
      searchQuery?.filterStatus,
      fetch,
    ]);
    return {
      config_templates_loading: status === STATUS.LOADING,
      config_templates_error: status === STATUS.ERROR ? status : '',
      config_templates_data: configTemplates,
    };
  },

  async createConfigurationTemplate(payload) {
    let res = await Fetch.post(`${this._url}/create-config-template`, payload);

    if (res.status >= 200 && res.status < 300) {
      res = await res.json();

      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
  async getConfigurationTemplates({ page = 1, pageSize = 10, searchText = '', startDate = '', endDate = '' }) {
    let res = await Fetch.get(
      `${this._url}/get-config-templates?page=${page}&itemsPerPage=${pageSize}&searchText=${searchText}&startDate=${startDate}&endDate=${endDate}`,
    );

    if (res.status >= 200 && res.status < 300) {
      res = await res.json();

      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
  async deleteConfigurationTemplate(id) {
    let res = await Fetch.delete(`${this._url}/delete-config-template/${id}`);

    if (res.status >= 200 && res.status < 300) {
      res = await res.json();

      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
  async editConfigurationTemplate(id, payload) {
    let res = await Fetch.put(`${this._url}/edit-config-template/${id}`, payload);

    if (res.status >= 200 && res.status < 300) {
      res = await res.json();

      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  // Device Configurations
  async updateConfiguration(payload) {
    let res = await Fetch.post(`${this._url}/update-config`, payload);

    if (res.status >= 200 && res.status < 300) {
      res = await res.json();

      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async getConfiguration(id) {
    let res = await Fetch.get(`${this._url}/get-config/${id}`);

    if (res.status >= 200 && res.status < 300) {
      res = await res.json();

      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
  async resyncConfiguration(serial_number) {
    let res = await Fetch.get(`${this._url}/resync-config/${serial_number}`);

    if (res.status >= 200 && res.status < 300) {
      res = await res.json();

      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
};

export default configurationService;
